<!--
 * @Author: Merlin
 * @Date: 2024-04-12 14:48:45
 * @LastEditors: Merlin
 * @LastEditTime: 2025-04-28 16:21:05
 * @Description: 目前只收集到了 html 结构，后面要观察是否采用这套内容
-->

<template>
    <div class="board-blackjack">
        <section class="board-blackjack-stage"
            v-observe-width
        >
            <TableLine
                dealer
                showResult
                style="height:37%;"
                :hands="oData4Show.handsBot"
            ></TableLine>
            <TableLine
                showResult
                style="height:37%;"
                :round="(history as any)" 
                :hands="oData4Show.hands"
                :hands2="oData4Show.hands2"
            ></TableLine> 
        </section>
        <!-- ↑ 牌桌 -->
        <!-- ↓ 分隔线 -->
        <div style="border-top: 1px solid rgb(28, 37, 50); margin: 20px 0px">
        </div>
        <!-- ↓ 下拉伸展的容器 -->
        <!-- ↓ 遍历两手牌 + 保险 --> 
        <section class="board-blackjack-list"
            v-for="(cur, idx) of aHands"
            :key="idx"
            @click="fnToShowDetail(idx)"
            :style="{'max-height': `${aVisible[idx] ? cur['maxHeight'] : 48}px`}" 
        >
            <div class="board-blackjack-list-header">
                <h2>
                    <IconSvgUse class="w-6 h-6" use="icon-campaign" />
                    {{ cur.sWord }}
                </h2>
                <QIcon class="text-white" :name="'collapsed' ? 'arrow_drop_up' : 'arrow_drop_down'" />
            </div>
            <!-- ↑标题 --> 
            <!-- ↓常驻项 1 --> 
            <div class="board-blackjack-list-item">
                <p class="board-blackjack-list-item-title"
                    v-if="cur.isFirstHand && (history.pairsBetAmount || history.tripleBetAmount)" 
                >
                    {{ $t('GameBlackJack.anteBet') }}
                </p>
                <div class="board-blackjack-list-item-body">
                    <div class="board-blackjack-list-item-body-block">
                        <h4>{{ $t('Bet') }}</h4>
                        <span onPurpose class="currency bet-details__info-bet">
                            <CurrentCoin />
                            <span class="amount-value">
                                <CasinoWidgetColoredAmount
                                    :colors="['', '#55657e']"
                                    :amount="cur.amount" 
                                ></CasinoWidgetColoredAmount>
                            </span>
                        </span>
                    </div>
                    <div class="board-blackjack-list-item-body-block">
                        <h4>{{ $t('commonInfo.coefficient') }}</h4>
                        <p class="board-blackjack-list-green">
                            x {{(cur as any).multi}} 
                        </p>
                    </div>
                    <div class="board-blackjack-list-item-body-block">
                        <h4>{{$t('roulette.payout')}}</h4>
                        <span onPurpose class="currency bet-details__info-bet">
                            <CurrentCoin />
                            <span class="amount-value">
                                <CasinoWidgetColoredAmount
                                    :colors="['', '#55657e']"
                                    :amount="cur.winAmount" 
                                ></CasinoWidgetColoredAmount>
                            </span>
                        </span>
                    </div>
                </div>
            </div>
            <!-- ↓ 动态项01： 完美对子 -->
            <div class="board-blackjack-list-item"
                v-if="cur.isFirstHand && history.pairsBetAmount"
            >
                <p class="board-blackjack-list-item-title">
                    {{ $t('GameBlackJack.PerfectPairs') }}
                </p>
                <div class="board-blackjack-list-item-body" >
                    <div class="board-blackjack-list-item-body-block">
                        <h4>{{ $t('Bet') }}</h4>
                        <span onPurpose class="currency bet-details__info-bet">
                            <CurrentCoin />
                            <span class="amount-value">
                                <CasinoWidgetColoredAmount
                                    :colors="['', '#55657e']"
                                    :amount="history.pairsBetAmount" 
                                ></CasinoWidgetColoredAmount>
                            </span>
                        </span>
                    </div>
                    <div class="board-blackjack-list-item-body-block">
                        <h4>{{ $t('commonInfo.coefficient') }}</h4>
                        <p class="board-blackjack-list-green">
                            x {{ (history.pairsWinAmount / history.pairsBetAmount).toFixed(2) }} 
                        </p>
                    </div>
                    <div class="board-blackjack-list-item-body-block">
                        <h4>{{$t('roulette.payout')}}</h4>
                        <span onPurpose class="currency bet-details__info-bet">
                            <CurrentCoin />
                            <span class="amount-value">
                                <CasinoWidgetColoredAmount
                                    :colors="['', '#55657e']"
                                    :amount="history.pairsWinAmount" 
                                ></CasinoWidgetColoredAmount>
                            </span>
                        </span>
                    </div>
                </div>
            </div>
            <!-- ↓ 动态项02： 21+3 -->
            <div class="board-blackjack-list-item"
                v-if="cur.isFirstHand && history.tripleBetAmount"
            >
                <p class="board-blackjack-list-item-title">
                    21+3
                </p>
                <div class="board-blackjack-list-item-body" >
                    <div class="board-blackjack-list-item-body-block">
                        <h4>{{ $t('Bet') }}</h4>
                        <span onPurpose class="currency bet-details__info-bet">
                            <CurrentCoin />
                            <span class="amount-value">
                                <CasinoWidgetColoredAmount
                                    :colors="['', '#55657e']"
                                    :amount="history.tripleBetAmount" 
                                ></CasinoWidgetColoredAmount>
                            </span>
                        </span>
                    </div>
                    <div class="board-blackjack-list-item-body-block">
                        <h4>{{ $t('commonInfo.coefficient') }}</h4>
                        <p class="board-blackjack-list-green">
                            x {{ (history.tripleWinAmount / history.tripleBetAmount).toFixed(2) }} 
                        </p>
                    </div>
                    <div class="board-blackjack-list-item-body-block">
                        <h4>{{$t('roulette.payout')}}</h4>
                        <span onPurpose class="currency bet-details__info-bet">
                            <CurrentCoin />
                            <span class="amount-value">
                                <CasinoWidgetColoredAmount
                                    :colors="['', '#55657e']"
                                    :amount="history.tripleWinAmount" 
                                ></CasinoWidgetColoredAmount>
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>


<script lang="ts" >
export default defineComponent({name: 'BlackJackContent'});
</script>

<script lang="ts" setup>
import TableLine from '@/pages/casino/blackjackGame/_components/TableLine.vue';
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';
import type { CardInterface, } from '@/pages/casino/blackjackGame/ts/blackjackGame.ts'; 
import { checkIfExploded } from '@/pages/casino/blackjackGame/ts/blackjackGame'; 
import useTranslation from '~/i18n/useTransLation';
const tt = useTranslation();


const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
        required: true,
        default: () => ({}),
    },
    fnScrollMove: { 
        type: Function,
    },
});


// ↓ 准备数据，用于传递给子组件 
const oData4Show = computed(()=>{
    const {dealerHand, firstHand, secondHand} = props.history;
    const oResult = {
        handsBot: ([] as CardInterface[]),
        hands: ([] as CardInterface[]),
        hands2: (null as CardInterface[]), 
    };
    const oOption = {goFast: true, exposed: true,};
    oResult.handsBot = dealerHand.cards.map(cur => {
        return {
            ...oOption,
            cardID: cur,
        };
    });
    if (checkIfExploded(props.history)){
        oResult.handsBot[1].cardID = 'card_close';
    }
    oResult.hands = firstHand.cards.map(cur => {
        return {
            ...oOption,
            cardID: cur,
        };
    });
    if (secondHand){
        (oResult.hands2 as CardInterface[]) = secondHand.cards.map(cur => {
            return {
                ...oOption,
                cardID: cur,
            };
        });
    }
    return oResult;
});

// ↓ 计算保险是不是已经生效了  
const hasUsedInsurance = computed(()=>{
    const { insuranceAmount, winAmount, firstHand, secondHand, dealerHand,} = props.history;
    const aConditions = [
        insuranceAmount > 0,
        winAmount > 0,
        dealerHand.points === 21,
        dealerHand.cards.length === 2,
        firstHand.winAmount == 0,
        !secondHand,
    ];
    const bResult = aConditions.every(Boolean);
    return bResult;
});


// ↓ 下注详情，用于页面显示 
const aHands = computed(()=>{
    const {
        firstHand,
        secondHand,
        pairsBetAmount,
        tripleBetAmount,
        winAmount,
        insuranceAmount,
    } = props.history;
    // ↓ 没有在 pro 模式下注。且只有1手牌 then 则不显示正文的详情
    if (!pairsBetAmount && !tripleBetAmount && !secondHand && !insuranceAmount){ 
        return [];
    }
    const aResult = [];
    if (insuranceAmount > 0){ 
        aResult[0] = {
            sWord: tt.GameBlackJack.insuranceItem, 
            amount: insuranceAmount,
            winAmount: 0, // 默认为 0 后赋值
        };
        if (hasUsedInsurance.value){
            aResult[0].winAmount = winAmount;
        }
    }
    const oFirstHand = {
        sWord: tt.GameBlackJack.betsList,
        isFirstHand: true,
        ...deepCopy(firstHand),
    }
    if (secondHand){
        oFirstHand.sWord = tt.GameBlackJack.handCard + ' 1';
    }
    aResult.push(oFirstHand);   
    if (secondHand){ 
        aResult.push({
            sWord: tt.GameBlackJack.handCard + ' 2',
            ...deepCopy(secondHand),
        });  
    }
    const iOneBlockHeight = 180; // 单行高度  
    aResult.forEach((cur, idx) => {
        if (cur.winAmount > 0){
            const iValue = cur.winAmount / cur.amount;
            cur['multi'] = iValue.toFixed(2);
        }else{
            cur['multi'] = '0.00';
        }
        cur['maxHeight'] = 50 + iOneBlockHeight;
        if ( cur.isFirstHand ){ 
            pairsBetAmount && (cur['maxHeight'] += iOneBlockHeight);
            tripleBetAmount && (cur['maxHeight'] += iOneBlockHeight);
        }
    });
    return aResult;
});



// ↓ 记录伸缩状态
const aVisible = ref([false, false, false]);

function fnToShowDetail(idx){
    const bNewValue = !aVisible.value[idx];
    aVisible.value[idx] = bNewValue;
    if (bNewValue){
        const iHeight = aHands.value[idx]['maxHeight'];
        props.fnScrollMove(iHeight);
    }
}

const vObserveWidth = {
    mounted(el) { 
        let timer01 = null; 
        el._resizeObserver = new ResizeObserver((entries) => {
            clearTimeout(timer01);
            timer01 = setTimeout(()=>{
                for (const entry of entries) {
                    const width = entry.target?.['offsetWidth']; // 获取最新高度（包含边框和滚动条）
                    entry.target?.['style'].setProperty('--the-width',  `${width}px`); 
                    // console.log('Height  updated:', height)
                }
            }, 100);
        });
        el._resizeObserver.observe(el); // 开始观察
    },
    beforeUnmount(el) {
        // 组件卸载时销毁观察器 
        if (el._resizeObserver) {
            el._resizeObserver.disconnect();
            delete el._resizeObserver;
        };
    },
};

</script>


<style scoped lang="scss">
.board-blackjack {
    // margin-bottom: -26px;  // 导致布局错误，关闭（实测中发现此项在完整版中表现良好） 
    margin-top: 1rem;
    width: 100%;
    &:after{
        content: ' ';
        display: block;
        height: 1px;
    }
}

.board-blackjack .statusText {
    display: none
}

.board-blackjack-stage {
    // padding: 15px 0; 
    height: calc(var(--the-width) * 0.49); 
    background-image: url(@/pages/casino/blackjackGame/img/greenBG.webp); 
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    position: relative;
    width: 100%;
}

.board-blackjack-list {
    background: #1c2532;
    border-radius: 14px;
    height: -moz-max-content;
    height: max-content;
    overflow: hidden;
    padding: 12px;
    // transition: all 1s;
    transition: all 0.5s;
    width: 100%;
    & + .board-blackjack-list{
        margin-top: 10px;
    }
}

// ↓ 关闭
// .board-blackjack-list:last-child {
//     margin-bottom: 0
// }

.board-blackjack-list-green {
    color: var(--accents-green-default,#1bb83d);
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: -.28px;
    line-height: 125%;
    margin: 0
}

.board-blackjack-list-header {
    cursor: pointer;
    display: flex;
    height: 24px;
    justify-content: space-between;
    align-items: center;
    // margin: 0 0 18px;
    width: 100%;
}

.board-blackjack-list-header h2 {
    align-items: center;
    display: flex;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    margin: 0
}

.board-blackjack-list-item {
    margin-top: 16px;
    width: 100%
}

.board-blackjack-list-item-title {
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    margin: 0 0 12px;
    text-align: center
}

.board-blackjack-list-item-body {
    display: grid;
    gap: 8px;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 60px
}

@media (max-width: 550px) {
    .board-blackjack-list-item-body {
        grid-template:60px 60px/1fr 1fr
    }
}


.board-blackjack-list-item-body-block {
    align-items: center;
    background: #263041;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    padding: 9px 0 11px;
    width: 100%;
}

.board-blackjack-list-item-body-block h4 {
    color: var(--dark-shades-gray-20,#93acd3);
    font-size: 12px;
    font-weight: 600;
    letter-spacing: -.24px;
    margin: 0;
    line-height: 1.8; // 追加  
}

@media (max-width: 550px) {
    .board-blackjack-list-item-body-block:nth-child(3) {
        grid-column:1/3
    }
}


.table-line {
    display: grid;
    grid-template-rows: 1fr;
    height: 37.7118%;
    width: 100%
}

.btn-grd-line {
    background: linear-gradient(90deg,#43536d00 -3%,#43536d 48.66%,#43536d00 103.12%);
    height: 1px;
    margin: 20px 0 0;
    widows: 100%
}


.bet-details__info-bet{
    display: flex;
    justify-content: center;
    align-items: center;
    .amount-value{
        font-size: 14px;
        margin-left: 3px;
        font-weight: 600;
    }
}
</style>




